export default "__VITE_ASSET__b481ad08__"